'use client';

import { createContext, useContext } from 'react';

type ModalContextStateValue = {
    open: boolean;
};

type ModalContextActionsValue = {
    open: () => void;
    close: () => void;
};

export const ModalContextState = createContext<ModalContextStateValue | null>(
    null
);

export const ModalContextActions =
    createContext<ModalContextActionsValue | null>(null);

export function useModalState() {
    const context = useContext(ModalContextState);

    if (!context) {
        throw new Error(
            'useModalContext must be used within a ModalContext.Provider'
        );
    }

    return context;
}

export function useModalActions() {
    const context = useContext(ModalContextActions);

    if (!context) {
        throw new Error(
            'useModalActions must be used within a ModalContext.Provider'
        );
    }

    return context;
}
